import * as types from "../_constants";
import axios from "axios";
import {
  CREATE_NEW_RECOMMENDATION_SUCCESS,
  CREATE_NEW_RECOMMENDATION_FAILURE,
  DELETE_RECOMMENDATION_SUCCESS,
  DELETE_RECOMMENDATION_FAILURE,
  GET_RECOMMENDATION_SUCCESS,
  GET_RECOMMENDATION_FAILURE,
  UPDATE_RECOMMENDATION_FAILURE,
  CLEAR_RECOMMENDATION_STATE
} from '../_constants'

import {
  recommendationListAPI,
  recommendationUpdateAPI,
  header,
  params,
} from "../_api";

export const getRecommendationList = (findingRuleId, machine_type,hmi_type,scope) => {
  return async (dispatch) => {
    return axios
      .get(recommendationListAPI, {
        params: {
          ...params,
          finding_rule_id: findingRuleId,
          machine_type: machine_type,
          hmi_type:hmi_type,
          scope: scope,
          userid: sessionStorage.getItem('userId')
        },
        headers: header,
      })
      .then((response) => {
        const data = response.data;
        dispatch(getRecommendationListSuccess(data));
      })
      .catch((error) => {
        const errorMsg = error.response.data.message;
        dispatch(getRecommendationListFailure(errorMsg));
      });
  };
};

export const getRecommendationListSuccess = (data) => {
  return {
    type: types.FETCH_RECOMMENDATION_SUCCESS,
    payload: data,
  };
};

export const getRecommendationListFailure = (error) => {
  return {
    type: types.FETCH_RECOMMENDATION_FAILURE,
    payload: error,
  };
};

export const getAllRecommendationList = (machine_type, hmi_type) => {
  return async (dispatch) => {
    dispatch(getRecommendationListRequest())
    return axios
      .get(recommendationListAPI, {
        params: {
          ...params,
          machine_type: machine_type,
          hmi_type:hmi_type,
          userid: sessionStorage.getItem('userId')
        },
        headers: header,
      })
      .then((response) => {
        const data = response.data;

        dispatch(getAllRecommendationListSuccess(data));
      })
      .catch((error) => {
        const errorMsg = error.response.data.message;
        dispatch(getAllRecommendationListFailure(errorMsg));
      });
  };
};

export const getRecommendationListRequest = () =>{
  return{
    type: types.FETCH_RECOMMENDATION_REQUEST
  }
}

export const getAllRecommendationListSuccess = (data) => {
  return {
    type: types.FETCH_ALL_RECOMMENDATION_SUCCESS,
    payload: data,
  };
};

export const getAllRecommendationListFailure = (error) => {
  return {
    type: types.FETCH_ALL_RECOMMENDATION_FAILURE,
    payload: error,
  };
};

export const  updateRecommendationList = (body, machine_type,hmi_type) => {
  return async (dispatch) => {
    return axios({
      method: "post",
      url: recommendationUpdateAPI,
      params: {
        ...params,
        machine_type: machine_type,
        hmi_type:hmi_type,
        userid: sessionStorage.getItem('userId')
      },
      headers: header,
      data: body,
    })
      .then((response) => {
        dispatch(updateRecommendationListSuccess(response.data));
      })
      .catch((error) => {
        const errorMsg = error.response.data.message;
        dispatch(updateRecommendationListFailure(errorMsg));
      });
  };
};

const updateRecommendationListSuccess = (data) => {
  return {
    type: types.FETCH_UPDATERECOMMENDATION_SUCCESS,
    payload: data,
  };
};

const updateRecommendationListFailure = (data) => {
  return {
    type: types.FETCH_UPDATERECOMMENDATION_FAILURE,
    payload: data,
  };
};

export const deleteRecommendationList = (id,scope, findingId,machine_type,hmi_type) => {
  return async (dispatch) => {
    return axios({
      method: "delete",
      url: recommendationUpdateAPI,
      params: {
        ...params,
        scope: scope,
        recommendation_id: id,
        scoped_finding_rule_id: findingId,
        machine_type:machine_type,
        hmi_type:hmi_type,
        userid: sessionStorage.getItem('userId')
      },
      headers: header
    })
    .then((response) => {
      dispatch(deleteRecommendationListSuccess(response.data));
    })
    .catch((error) => {
      const errorMsg = error.response.data.message;
      dispatch(deleteRecommendationListFailure(errorMsg));
    });
  };
};

const deleteRecommendationListSuccess = (data) => {
  return {
    type: types.FETCH_DELETE_RECOMMENDATION_SUCCESS,
    payload: data,
  };
};

const deleteRecommendationListFailure = (data) => {
  return {
    type: types.FETCH_DELETE_RECOMMENDATION_FAILURE,
    payload: data,
  };
};

const createNewRecommendationSuccess = (data) => {
  return { type: CREATE_NEW_RECOMMENDATION_SUCCESS, payload: data };
};

const createNewRecommendationFailure = (error) => {
  return { type: CREATE_NEW_RECOMMENDATION_FAILURE, payload: error };
};

export const createNewRecommendation = (body,machine_type, hmi_type, handleCreateRecommendation) => {
  return async (dispatch) => {
    return axios({
      method: "POST",
      url: recommendationListAPI,
      params: {
        ...params,
        machine_type:machine_type,
        hmi_type:hmi_type,
        userid: sessionStorage.getItem('userId')
      },
      headers: header,
      data: body,
    })
      .then((response) => {
        dispatch(createNewRecommendationSuccess(response.data));
        handleCreateRecommendation(true);
      })
      .catch((error) => {
        const errorMsg = error.response.data.message;
        handleCreateRecommendation(false);
        dispatch(createNewRecommendationFailure(errorMsg));
      });
  };
};

const getRecommendationSuccess = (data) => {
  return { type: GET_RECOMMENDATION_SUCCESS, payload: data }
}

const getRecommendationFailure = (error) => {
  return { type: GET_RECOMMENDATION_FAILURE, payload: error }
}

export const getRecommendation = (id,machine_type,hmi_type) => {
  return async (dispatch) => {
    return axios
      .get(`${recommendationListAPI}${id}`+ "/", {
        params: {
          ...params,
          machine_type:machine_type,
          hmi_type:hmi_type,
          view: 'with_scoped_finding_rule',
          userid: sessionStorage.getItem('userId')
        },
        headers: header,
      })
      .then((response) => {
        const data = response.data
        dispatch(getRecommendationSuccess(data))
      })
      .catch((error) => {
        const errorMsg = error.response.data.message
        dispatch(getRecommendationFailure(errorMsg))
      })
  }
}

const updateRecommendationFailure = (error) => {
  return { type: UPDATE_RECOMMENDATION_FAILURE, payload: error }
}

export const updateRecommendation = (body, handleUpdateSuccess, machine_type, hmi_type) => {
  return async (dispatch) => {
    return axios({
      method: 'PUT',
      url: recommendationListAPI,
      params: {
        ...params,
        machine_type:machine_type,
        hmi_type:hmi_type,
        userid: sessionStorage.getItem('userId')
      },
      headers: header,
      data: body,
    })
      .then((response) => {
        handleUpdateSuccess(true)
      })
      .catch((error) => {
        const errorMsg = error.response.data.message
        dispatch(updateRecommendationFailure(errorMsg))
      })
  }
}

export const clearRecommendationState = (error) => {
  return { type: CLEAR_RECOMMENDATION_STATE, payload: error }
}

const deleteRecommendationSuccess=(data) => {
  return {type: DELETE_RECOMMENDATION_SUCCESS, payload: data};
}

const deleteRecommendationFailure = (error) => {
  return {type: DELETE_RECOMMENDATION_FAILURE,payload: error}
}

export const deleteRecommendation = (recommendationId,handleDeleteSuccess,machine_type, hmi_type) => {
return async (dispatch)=>{
  return axios({
    method: "DELETE",
    url: recommendationListAPI,
    params:{
      ...params,
      machine_type:machine_type,
      hmi_type:hmi_type,
      recommendation_id : recommendationId,
      userid: sessionStorage.getItem('userId')
    },
    headers: header
  })
  .then((response)=>{
    dispatch(deleteRecommendationSuccess(response.data))
    handleDeleteSuccess(true)
  })
  .catch((error)=>{
    const errorMsg = error.response.data.message;
    dispatch(deleteRecommendationFailure(errorMsg))
  })
 }
}